import { IGlobalState } from '../states/GlobalState';
import { GetConfiguration } from "../utils/config";
import Auth, { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { getHeadersForSSO, handleErrorsForSSO } from './identityService';
import { Agency, AgencySearchModel } from '../models/agency';
import { Result } from '../models/objects';

export const getAgencies = (ip: string, authData: AuthDataType, user: User, model: AgencySearchModel): Promise<Result<Agency>> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Get Agencies body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/agency/search`
    console.log('Get Agencies', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`GetAgencies ("${authData.user}") -> letti ${json.length} agencies`);
            console.log('GetAgencies recuperato json: ' + JSON.stringify(json));
            const rv = json as Result<Agency>;
            let result: Result<Agency> = new Result<Agency>();
            result.ResultList = [];
            result.ListLength = 0;
            let items: Agency[] = rv.ResultList;
            console.log('GetAgencies recuperate: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('GetAgencies error:', error);
            throw error;
        });
}

export const getAgency = (ip: string, authData: AuthDataType, user: User, id: number): Promise<Agency> => {        
    console.log('Get Agency id: ', + id);
    const url = `${GetConfiguration().api_url}/agency/${id}`
    console.log('Get Agency', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getAgency ("${authData.user}") -> letti ${json.length} agency`);
            console.log('getAgency recuperata json: ' + JSON.stringify(json));
            const rv = (json as Agency);
            console.log('getAgency recuperata agency: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getAgency error:', error);
            throw error;
        });
}

export const updateAgency = (ip: string, authData: AuthDataType, user: User, model: Agency): Promise<Agency> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Insert/Update Agency con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/agency`
    console.log('Update Agency', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`updateAgency ("${authData.user}") -> letti ${json.length} agency`);
            console.log('updateAgency recuperata json: ' + JSON.stringify(json));
            const rv = (json as Agency);
            console.log('updateAgency recuperata agency: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('updateCompanies error:', error);
            throw error;
        });
}

export const deleteAgency = (ip: string, authData: AuthDataType, user: User, id: number): Promise<boolean> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    // console.log('Update Agency con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/agency`
    console.log('Delete Agency', url);
    return window.fetch(url, {
        method: 'DELETE',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(id)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            // console.log(`deleteAgency ("${authData.user}") -> letti ${json.length} agency`);
            console.log('deleteAgency avente id: ' + id);
            const rv = (json as boolean);
            return rv;
        })
        .catch(error => {
            console.log('deleteCompanies error:', error);
            throw error;
        });
}
